import React from 'react';
import styles from "./InventoryLevelsFulfillment.module.scss";
import DynamicTableFilters from '../../../../common/AdminCommonComponents/DynamicTableFilters/DynamicTableFilters';
import DynamicDatatable from '../../../../common/AdminCommonComponents/DynamicDatatable/DynamicDatatable';
import { inventoryLevelsTableData } from '../../../../../views/AdminPortal/dummyData';
import { useNavigate } from 'react-router-dom';
import StatusBadge from '../../../../common/AdminCommonComponents/StatusBadge/StatusBadge';
import ActionButton from '../../../../common/AdminCommonComponents/Buttons/ActionButton/ActionButton';

const InventoryLevelsFulfillment = () => {
    const navigate = useNavigate();

    const lowOptions = [
        { label: "View detail", action: () => navigate('/ordermanagement/orderfulfillment/inventorydetail') },
        { label: "Deactivate Product", action: () => console.log("Deactivate Product") },
        { label: "Notify Seller", action: () => console.log("Notify Seller") },
    ];

    const ampleOptions = [
        { label: "View detail", action: () => navigate('/ordermanagement/orderfulfillment/inventorydetail') },
        { label: "Activate Product", action: () => console.log("Activate Product") },
        { label: "Notify Seller", action: () => console.log("Notify Seller") },
    ];

    const columns = [
        {
            name: "Sr.",
            selector: (_, index) => index + 1,
            center: "true",
            width: "80px",
        },
        {
            name: "Seller ID",
            selector: (row) => row.sellerId,
            center: "true",
            width: "150px",
        },
        {
            name: "Product SKU",
            selector: (row) => row.productSku,
            center: "true",
            minWidth: "180px",
        },
        {
            name: "Product Name",
            selector: (row) => row.productName,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Current Stock",
            cell: (row) => <StatusBadge statusName={row.stock} />,
            center: "true",
            minWidth: "140px",
        },
        {
            name: "Allocated for Orders",
            selector: (row) => row.allocatedOrders,
            center: "true",
            minWidth: "200px",
        },
        {
            name: "Available for New Orders",
            selector: (row) => row.availableNewOrders,
            center: "true",
            minWidth: "220px",
        },
        {
            name: "Action",
            cell: (row) => <ActionButton options={row.stock === "Low" ? lowOptions : ampleOptions} />,
            center: "true",
        },
    ];

    const handleApply = (filters) => {
        console.log("Applied Filters:", filters);
    };

    const handleClear = () => {
        console.log("Filters Cleared");
    };

    return (
        <div>
            <DynamicTableFilters componentName={"Inventory Levels for Fulfillment"} onApply={handleApply} onClear={handleClear} />
            <div className={styles.tableWrapper}>
                <DynamicDatatable
                    data={inventoryLevelsTableData}
                    columns={columns}
                    type="gray"
                    pagination
                    highlightOnHover
                    responsive
                />
            </div>
        </div>
    );
};

export default InventoryLevelsFulfillment;